<h3 class="preset-title-3 md:preset-title-2 text-center text-white">Política de privacidad - Fórmula Tonicorp</h3>

<div class="preset-body-3 md:preset-body-2 mt-4 flex flex-col gap-6 text-white">
  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">I. “Responsable del Tratamiento” de sus datos personales</h4>
    <p>
      DISTRIBUIDORA IMPORTADORA DIPOR S.A. (Tonicorp), junto con sus afiliadas, subsidiarias, empresa matriz y/o partes relacionadas (en adelante, "LA EMPRESA" o el "Responsable del tratamiento"), es el responsable del
      tratamiento de sus datos personales. De conformidad con la Ley Orgánica de Protección de Datos Personales (LOPDP) de la República del Ecuador y demás normativa aplicable (en adelante, la "Ley"), Tonicorp decide
      sobre cómo se tratan los datos personales que recaba de usted, el "Titular" de dichos datos. Se entiende por dato personal cualquier información que identifique o pueda identificar a una persona natural.
    </p>

    <p>
      LA EMPRESA tratará sus datos personales de manera legítima y de acuerdo con la Ley. Esta Política de Privacidad complementa cualquier otro aviso de privacidad más breve que Tonicorp le haya proporcionado y
      prevalecerá en caso de que existan aspectos no detallados en aquellos.
    </p>

    <p>
      Sus datos personales serán recolectados electrónicamente y/o directamente por Tonicorp o por DISTRIBUIDORA IMPORTADORA DIPOR S.A., quien actuará como "Operador del tratamiento" en los términos establecidos por la
      Ley y bajo las directrices de esta Política de Privacidad.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">II. Domicilio del “Responsable del tratamiento”</h4>
    <p>Para cualquier notificación relacionada con esta Política de Privacidad, se señala como domicilio del Responsable del tratamiento la siguiente dirección: Vía Daule # Km 10.5 Guayaquil, Ecuador.</p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">III. Datos personales que recaba el “Responsable del tratamiento”</h4>
    <p>
      Usted puede navegar en nuestro sitio web sin proporcionar datos personales, sin embargo, en caso de que decida contactarnos, registrarse o inscribirse a cualquiera de nuestros programas, promociones, trivias,
      encuestas o entrar a ciertos apartados en los cuales usted puede voluntariamente proporcionar sus datos para las distintas finalidades aquí descritas.
    </p>

    <p>
      <strong>Para contactarnos:</strong> Al contactarnos a través de cualquier página web de Tonicorp, podremos recabar los siguientes datos personales: nombre completo, correo electrónico, edad, género, CURP, y número
      de teléfono.
    </p>

    <p>
      <strong>Para registro/inscripción:</strong> Al registrarse o inscribirse en nuestros programas, promociones, trivias, encuestas y concursos, podremos recabar los siguientes datos personales: nombre completo, correo
      electrónico, género, número de teléfono.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">IV. Datos personales sensibles</h4>
    <p>A EMPRESA le informa que para cumplir con las finalidades previstas en este aviso de privacidad no requiere recabar de usted datos personales sensibles.</p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">V. Finalidades del tratamiento de los datos personales recabados</h4>
    <p>El “Responsable del tratamiento” recabará sus datos personales dependiendo de las circunstancias que generen su relación con usted para las siguientes finalidades:</p>

    <ul>
      <li>Dar seguimiento y responder a sus dudas, comentarios o sugerencias realizadas a través de nuestra página web.</li>
      <li>Crear un expediente interno para la gestión de los servicios contratados.</li>
      <li>Registrarlo, inscribirlo y darlo de alta en nuestros programas, trivias, encuestas, promociones y concursos.</li>
      <li>Crear un expediente interno para la administración de nuestros programas, trivias, encuestas, promociones y concursos.</li>
      <li>Cumplir con las obligaciones contractuales adquiridas con usted.</li>
      <li>Comunicarle e informarle sobre cualquier cambio en los programas, trivias, encuestas, promociones y concursos en los que se haya registrado o inscrito.</li>
      <li>
        Recabar datos de geolocalización y demográficos sobre la ubicación de su dispositivo al contactarnos o solicitar nuestros servicios, así como datos sobre sus preferencias e intereses en nuestros bienes, productos
        y servicios.
      </li>
      <li>Realizar análisis de datos en nuestra página web y/o aplicación mediante tecnologías de inteligencia artificial y similares para fines estadísticos e históricos.</li>
      <li>Enviar y/o gestionar la entrega de premios y artículos que haya ganado en nuestros programas, trivias, encuestas, promociones y concursos.</li>
      <li>Contactarlo para iniciar o dar continuidad a su participación en cualquiera de nuestros programas, trivias, encuestas, promociones y concursos.</li>
    </ul>

    <p>
      De manera adicional, utilizaremos su información personal para las siguientes finalidades que no son necesarias para mantener una relación con usted, pero que nos permiten y facilitan brindarle una mejor atención:
    </p>

    <ul>
      <li>Evaluar la calidad de nuestros servicios profesionales, programas, trivias, encuestas, promociones y concursos, y realizar encuestas de satisfacción al cliente.</li>

      <li>Realizar prospección comercial personalizada, ofreciéndole nuestros productos, servicios, ofertas y promociones.</li>
      <li>Elaborar estudios estadísticos, como encuestas y análisis sobre hábitos de consumo y de mercado.</li>
      <li>
        Enviarle correos electrónicos con información e invitaciones a eventos, programas, trivias, encuestas, promociones y concursos que puedan ser de su interés, de acuerdo con los servicios que le hemos prestado.
      </li>
    </ul>

    <p>
      Finalmente, los nombres y fotografías de los participantes serán recopilados y almacenados en nuestra plataforma con fines comerciales y promocionales. Al aceptar esta Política de Privacidad, usted otorga su
      <strong>consentimiento explícito</strong> para que sus datos personales sean tratados y utilizados para esta finalidad. Nos comprometemos a proteger su privacidad y a cumplir con la normativa aplicable en materia
      de protección de datos personales. Si desea oponerse al tratamiento de sus datos personales para las finalidades secundarias (no necesarias), incluyendo esta, por favor envíe un correo a
      <a href="mailto:derechosarcoecu&#64;arcacontal.com">derechosarcoecu&#64;arcacontal.com</a>
      indicando su oposición.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">VI. Opciones y medios para limitar el uso o divulgación de sus datos personales</h4>
    <p>
      Para limitar el uso o divulgación de sus datos personales con fines de publicidad o mercadeo por parte de Tonicorp, puede contactar directamente a nuestro Departamento de Datos Personales en la dirección indicada o
      a través del correo electrónico
      <a href="mailto:derechosarcoecu&#64;arcacontal.com">derechosarcoecu&#64;arcacontal.com</a>, donde le informaremos sobre los procedimientos disponibles para ejercer este derecho.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">VII. Medios para ejercer los Derechos de acceso, rectificación, eliminación, oposición, portabilidad, suspensión y a no ser objeto de decisiones automatizadas.</h4>
    <p>Usted tiene los siguientes derechos sobre sus datos personales en posesión de Tonicorp:</p>

    <ul>
      <li><strong>Acceso:</strong> Conocer qué datos personales tenemos y cómo los estamos utilizando.</li>
      <li><strong>Rectificación:</strong> Solicitar la corrección de sus datos si son inexactos o incompletos.</li>
      <li><strong>Eliminación:</strong> Solicitar la supresión de sus datos cuando considere que ya no son necesarios para las finalidades para las que fueron recogidos o cuando haya revocado su consentimiento.</li>
      <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos para finalidades específicas.</li>
      <li><strong>Portabilidad:</strong> Recibir una copia de sus datos en un formato estructurado, de uso común y lectura mecánica, y transmitirlos a otro responsable del tratamiento.</li>
      <li>
        <strong>Suspensión:</strong> Solicitar la suspensión del tratamiento de sus datos en ciertos casos, por ejemplo, mientras se Suspensión: Solicitar la suspensión del tratamiento de sus datos en ciertos casos, por
        ejemplo, mientras se verifica la exactitud de los mismos.
      </li>
      <li>
        <strong>Derecho a no ser objeto de decisiones automatizadas:</strong> No ser objeto de una decisión basada únicamente en el tratamiento automatizado de sus datos, incluida la elaboración de perfiles, que produzca
        efectos jurídicos en usted o le afecte significativamente de modo similar.
      </li>
    </ul>

    <p>
      El proceso para ejercer estos derechos, de acuerdo con la legislación ecuatoriana, se inicia con la presentación de una solicitud dirigida al Área Legal - Departamento de Datos Personales de Tonicorp, en la
      siguiente dirección o a través del correo electrónico
      <a href="mailto:derechosarcoecu&#64;arcacontal.com"> derechosarcoecu&#64;arcacontal.com</a>. Su solicitud deberá contener al menos la siguiente información:
    </p>

    <ul>
      <li>Su nombre completo y un medio (dirección física o electrónica) para comunicarle la respuesta.</li>
      <li>Una copia de su documento de identidad o, en su caso, el documento que acredite su representación legal.</li>
      <li>Una descripción clara y precisa de los datos personales sobre los que desea ejercer alguno de los derechos mencionados.</li>
      <li>Cualquier otro documento o información que facilite la ubicación de sus datos personales.</li>
    </ul>

    <p>
      Antes de iniciar el ejercicio de sus derechos, le sugerimos contactar a nuestro Departamento de Datos Personales (a través de los medios indicados) para obtener información adicional y los formatos necesarios para
      facilitar este proceso.
    </p>

    <p>
      Usted tiene el derecho de acceder a sus datos personales en posesión de Tonicorp, así como a los detalles y características del tratamiento de los mismos, a rectificarlos en caso de ser inexactos o incompletos; y a
      cancelarlos cuando considere que no se requieren para alguna de las finalidades antes señaladas, o en caso de que usted considere que estén siendo utilizados para finalidades no consentidas; o bien oponerse al
      tratamiento de los mismos.
    </p>

    <p>
      <strong> Procedimiento para que el titular, en su caso, revoque su consentimiento para el tratamiento de sus datos personales. </strong>
      En cualquier momento, usted puede revocar el consentimiento que, en su caso, haya otorgado a LA EMPRESA para el tratamiento de sus datos personales. Sin embargo, no en todos los casos se podrá atender su solicitud
      o concluir el uso de forma inmediata, ya que es posible que, por alguna obligación legal Tonicorp deba o requiera continuar con el tratamiento de sus datos personales. Asimismo, usted debe tener en cuenta que,
      tratándose de ciertas finalidades específicas, la revocación de su consentimiento implicará la terminación de su relación con el Tonicorp.
    </p>

    <p>
      En caso de querer revocar su consentimiento será necesario que contacte al Departamento de Datos Personales, ubicado en el domicilio de Tonicorp, o a través de la siguiente dirección de correo electrónico
      <a href="mailto:derechosarcoecu&#64;arcacontal.com"> derechosarcoecu&#64;arcacontal.com </a>, a fin de que le puedan brindar la información y/o formatos necesarios para iniciar un eficiente procedimiento para la
      revocación del consentimiento.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">VIII. Transferencias de datos personales dentro de Ecuador y al extranjero.</h4>
    <p>
      Tonicorp no realizará transferencia alguna de sus datos personales a otros terceros. Sin embargo, el Tonicorp podrá llevar a cabo transferencias de sus datos sin su consentimiento en los supuestos previstos por la
      Ley, a través de encargados del tratamiento “operadores” dentro o fuera de Ecuador que puedan tener acceso a los datos para las finalidades descritas. En caso de existir, LA EMPRESA se compromete a informar sobre
      ellos.
    </p>

    <p>
      Asimismo, nuestra página web podría contener hipervínculos (links), banners y/o botones que pueden redirigir a los usuarios a otros portales o sitios de Internet propiedad de u operados por terceros y otros
      servicios que pueden estar compartidos con terceros. Los datos personales que los usuarios proporcionen en dichos portales o sitios de Internet no se encuentran amparados bajo este aviso de privacidad, por lo
      tanto, su tratamiento no es responsabilidad de Tonicorp. Cualquier información proporcionada por los usuarios en sitios o portales de terceros se sujetará a los respectivos avisos de privacidad que se contengan en
      cada uno de ellos. Redireccionar a páginas de terceros, por lo que Tonicorp no será responsable del tratamiento de datos personales que dichos terceros realicen.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">IX. RECOLECCIÓN DE DATOS PERSONALES A TRAVÉS DE COOKIES Y WEB BEACONS</h4>
    <p>Tonicorp recaba datos personales directamente del titular o a través de otros medios ópticos, sonoros, visuales, gráficos, o por cualquier otra tecnología legalmente permitida.</p>
    <p>
      La información que Tonicorp recibe y almacena de las páginas de internet y/o aplicaciones móviles cuando usted interactúa en los sitios web y/o aplicaciones de Tonicorp es principalmente información técnica, como
      su dirección de protocolo de internet, su sistema operativo en su dispositivo y su tipo de navegador, la dirección de un sitio web de referencia, en su caso, y la ruta que siga durante su recorrido por la página
      web y/o aplicación.
    </p>

    <p>
      Cuando visita nuestras páginas web y/o aplicaciones, los “datos de uso” temporales se guardan como un registro en nuestro servidor con fines estadísticos para mejorar la calidad de nuestros sitios web. Este
      conjunto de datos comprende:
    </p>

    <ul>
      <li>La página web y/o aplicación mediante la cual los datos fueron requeridos;</li>
      <li>El nombre de los datos;</li>
      <li>La fecha y hora de la solicitud;</li>
      <li>El volumen de datos transferidos;</li>
      <li>El estado de acceso (archivo transferido, archivo no encontrado);</li>
      <li>La descripción del tipo de navegador web utilizado; y</li>
      <li>La dirección IP del dispositivo solicitante, acortada a los últimos tres caracteres.</li>
    </ul>

    <p>
      LA EMPRESA usa esta información para permitir el acceso a nuestra página web y/o aplicación, para el control y la administración de nuestros sistemas, y para mejorar el diseño de las páginas web y/o aplicaciones.
      La información guardada es anonimizada (disociada).
    </p>

    <p>
      “No rastrear” es una configuración de navegador opcional que permite a los usuarios optar por dejar de rastrear los sitios web que visitan, incluidos servicios de análisis, redes publicitarias y plataformas
      sociales. Puede ajustar la configuración en su navegador y optar por “No rastrear”. Una vez que haya hecho esto, se enviará una solicitud de “No rastrear” cuando acceda a un sitio web desde su navegador, y su
      actividad de usuario no será rastreada.
    </p>

    <p>
      LA EMPRESA utiliza cookies para reconocerlo cuando utilice o regrese a sus sitios web. Las cookies permiten a LA EMPRESA reconocerlo de página en página. Las cookies son pequeños archivos de texto que los sitios
      web que usted visita colocan en su dispositivo. Son ampliamente utilizados para hacer que los sitios web funcionen o funcionen de manera más eficiente, así como para proporcionar información a los propietarios del
      sitio web. Esta página web y/o aplicación utiliza cookies de sesión para permitirle iniciar sesión en su cuenta de usuario personalizada. Estas cookies de sesión no permanecen en la página web y/o aplicación o en
      su dispositivo después de cerrar la página web y/o aplicación. Esta página web y/o aplicación también usa Google® Analytics®. Si no desea que se utilicen las cookies, no utilice nuestro sitio web, ya que no se
      pueden desactivar.
    </p>

    <div class="max-w-full overflow-x-auto">
      <table class="border-primary-300 w-full min-w-200 table-auto border-collapse rounded border">
        <thead>
          <tr>
            <th class="border-primary-300 border p-1">Tipo de Cookie</th>
            <th class="border-primary-300 border p-1">Nombre</th>
            <th class="border-primary-300 border p-1">Objectivo</th>
            <th class="border-primary-300 border p-1">Información adicional</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border-primary-300 border p-1">Temporal</td>
            <td class="border-primary-300 border p-1">bud_auth</td>
            <td class="border-primary-300 border p-1">Autenticación del usuario -- sin esta cookie, el usuario no podría iniciar sesión.</td>
            <td class="border-primary-300 border p-1">Expira al finalizar la sesión.</td>
          </tr>
          <tr>
            <td class="border-primary-300 border p-1">Temporal</td>
            <td class="border-primary-300 border p-1">bud_session</td>
            <td class="border-primary-300 border p-1">Estado de sesión del usuario conectado -- sin esta cookie el usuario tendría que iniciar sesión para ver cada página.</td>
            <td class="border-primary-300 border p-1">Expira al finalizar la sesión.</td>
          </tr>
          <tr>
            <td class="border-primary-300 border p-1">Temporal & Permanente</td>
            <td class="flex flex-col gap-2">
              <span>__utma</span>
              <span>__utmb</span>
              <span>__utmc</span>
              <span>__utmz</span>
            </td>
            <td class="border-primary-300 border p-1">
              Google® Analytics®y Salesforce Krux utilizan cookies para ayudarnos a analizar cómo usa esta página web y/o aplicación. Usamos la información para compilar informes y ayudarnos a mejorar. Las cookies
              recopilan información de forma anónima, incluida la cantidad de visitantes, desde donde los visitantes han accedido a la página web y/o aplicación que visitaron. Para obtener una descripción general de
              privacidad de Google, haga clic
              <a href="#">aquí</a>.
            </td>
            <td class="border-primary-300 border p-1">
              _utma expira 2 años después de su creación utmb expira 30 minutos después del último acceso a la página web_utmc expira 30 minutos después del último acceso a la página web _utmz expira 6 meses después del
              último acceso a la página web.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p>
      Tipo de Cookie Nombre Objetivo Información Adicional Temporal bud_auth Autenticación del usuario -- sin esta cookie, el usuario no podría iniciar sesión. Expira al finalizar la sesión. Temporal bud_session Estado
      de sesión del usuario conectado -- sin esta cookie el usuario tendría que iniciar sesión para ver cada página. Expira al finalizar la sesión. Temporal & Permanenteutma utmb utmc utmz ____________________ Google
      Analytics y Salesforce Krux utilizan cookies para ayudarnos a analizar cómo usa esta página web y/o aplicación. Usamos la información para compilar informes y ayudarnos a mejorar. Las cookies recopilan información
      de forma anónima, incluida la cantidad de visitantes, desde donde los visitantes han accedido a la página web y/o aplicación que visitaron. Para obtener una descripción general de privacidad de Google, haga clic
      <a href="#">aquí</a>. _utma expira 2 años después de su creación ____________________ utmb expira 30 minutos después del último acceso a la página web_utmc expira 30 minutos después del último acceso a la página
      web _utmz expira 6 meses después del último acceso a la página web.
    </p>
    <p>
      La mayoría de los navegadores web permiten cierto control de la mayoría de las cookies a través de la configuración del navegador. Para obtener más información sobre las cookies, incluida la forma de ver qué
      cookies se han establecido y cómo administrarlas y eliminarlas, visite
      <a href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a>.
    </p>
    <p>Es importante mencionar que, si elige deshabilitar por completo el uso de cookies en su navegador, es posible que esta página web y/o aplicación no se muestre o no funcione como se diseñó en su dispositivo.</p>
    <p>
      Esta página web y/o aplicación utiliza herramientas de análisis web que utilizan cookies y dispositivos similares para permitirnos analizar el uso de esta página web y/o aplicación. Para que podamos optimizar
      nuestra página web y/o aplicación, la información generada en la cookie (incluida la dirección IP abreviada) se transmite a nuestro servidor y se almacena. Durante este proceso, su dirección de IP será
      inmediatamente anonimizada (disociada), para que usted permanezca en el anonimato. La información generada por la cookie sobre su uso de este sitio web no será divulgada a terceros.
    </p>
    <p>
      Realizamos anuncios adaptados a sus intereses mediante la cooperación con redes publicitarias, proveedores de anuncios publicitarios y servicios similares. Podemos recopilar información sobre su actividad en línea
      a través de tecnologías de seguimiento tales como cookies, píxeles de seguimiento y dispositivos similares, para realizar anuncios y servicios en línea que sean relevantes para usted. Puede obtener más información
      acerca de la publicidad dirigida y tomar ciertas decisiones de privacidad <a href="#">aquí</a>.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">X. Medidas de seguridad implementadas</h4>
    <p>Para la protección de sus datos personales hemos instrumentado medidas de seguridad de carácter administrativo, físico y técnico con el objeto de evitar pérdidas, mal uso y/o alteración de su información.</p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">XI. Modificaciones al aviso de privacidad</h4>
    <p>
      El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales, de las propias necesidades de Tonicorp por los servicios que se ofrecen, de las
      prácticas de privacidad o diversas causas, por lo que Tonicorp se reserva el derecho de efectuar en cualquier momento las modificaciones o actualizaciones que sean necesarias al presente aviso de privacidad.
    </p>
    <p>LA EMPRESA pondrá a su disposición, la versión actualizada del aviso de privacidad, en el sitio web y/o la aplicación de Tonicorp.</p>
    <p>
      <strong> Derecho de promover los procedimientos de protección de derechos y de verificación que sustancia el Instituto. </strong>
      Cualquier queja o información adicional respecto al tratamiento de sus datos personales o duda en relación con la Ley, podrá dirigirla a la
      <strong>Superintendencia de Protección de Datos Personales de Ecuador.</strong>
    </p>
  </article>
</div>
